<script lang="ts" setup>
import TermsPage from '@consumer/modules/legal/TermsPage.vue'
</script>

<template>
  <TermsPage/>
</template>
